export enum ESearchState {
  READY = "true",
  LOADING = "loading",
  NOTREADY = "false"
}
